import React, { useEffect } from 'react'
import { MFASelectionScreen } from '../Components'
import styled from '@emotion/styled'
import { font, spacing } from '@mobi/component-library/Theme/Common'
import { MainContainer } from '@core/Components/Containers'
import { SettingsHeader } from '@core/Areas/Settings/SettingsHeader'
import { isCognitoUserAuthenticated } from '../Hooks/useCognitoUserIsAuthenticated'
import { useLogon } from '@core/Utils/hooks'

export const MFASelectionPage: React.FC = () => {
  const { accountNumber } = useLogon()

  useEffect(() => {
    // warm the cache to see if the user is_authenticated
    isCognitoUserAuthenticated(true)
  }, [])

  return (
    <MainContainer data-tid-mfa-selection-page>
      <SettingsHeader title='Settings' />
      <PageContainerStyled>
        <PageContentStyled>
          <HeaderStyled>Multi-factor Authentication (MFA)</HeaderStyled>
          {accountNumber ? <MFASelectionScreen accountNumber={accountNumber} /> : null}
        </PageContentStyled>
      </PageContainerStyled>
    </MainContainer>
  )
}

// ======
// Styles
// ======

const PageContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: `${spacing.bigx1} ${spacing.md}`,
  gap: '20px',
  p: { textAlign: 'left' },
})

const PageContentStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'stretch',
})

const HeaderStyled = styled.h1({
  margin: 0,
  fontFamily: font.family.primary,
  ...font.size.lg,
  fontWeight: font.weight.semibold,
})
